import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../../../components';
import { formatNumber } from '../../../../utils';
import { getDisk } from '../../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ConfigTypeItem = /*#__PURE__*/function (ConfigTypeItem) {
  ConfigTypeItem["Kafka2_4"] = "kafka.2u4g.cluster";
  ConfigTypeItem["Kafka4_8"] = "kafka.4u8g.cluster";
  ConfigTypeItem["Kafka8_16"] = "kafka.8u16g.cluster";
  ConfigTypeItem["Kafka12_24"] = "kafka.12u24g.cluster";
  ConfigTypeItem["Kafka16_32"] = "kafka.16u32g.cluster";
  return ConfigTypeItem;
}(ConfigTypeItem || {});
var configItems = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ConfigTypeItem.Kafka2_4, {
  parts: '7',
  partition: '250',
  tps: '30000',
  throughput: '100',
  usersConnectionsCount: '2000',
  usersGroupCount: '20'
}), ConfigTypeItem.Kafka4_8, {
  parts: '14',
  partition: '500',
  tps: '100000',
  throughput: '200',
  usersConnectionsCount: '4000',
  usersGroupCount: '100'
}), ConfigTypeItem.Kafka8_16, {
  parts: '27',
  partition: '1000',
  tps: '150000',
  throughput: '375',
  usersConnectionsCount: '4000',
  usersGroupCount: '150'
}), ConfigTypeItem.Kafka12_24, {
  parts: '41',
  partition: '1500',
  tps: '200000',
  throughput: '625',
  usersConnectionsCount: '4000',
  usersGroupCount: '200'
}), ConfigTypeItem.Kafka16_32, {
  parts: '50',
  partition: '2000',
  tps: '250000',
  throughput: '750',
  usersConnectionsCount: '4000',
  usersGroupCount: '200'
});
function getDescription(configType) {
  var rows = configItems[configType];
  var parts = rows.parts,
    partition = rows.partition,
    tps = rows.tps,
    throughput = rows.throughput,
    usersConnectionsCount = rows.usersConnectionsCount,
    usersGroupCount = rows.usersGroupCount;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formatNumber(Number(parts)), " \u0447\u0430\u0441\u0442\u0435\u0439 \u044F\u0434\u0440\u0430 \u0432\u0438\u0440\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0430 ", /*#__PURE__*/_jsx("br", {}), formatNumber(Number(partition)), " \u043F\u0430\u0440\u0442\u0438\u0446\u0438\u0439 ", /*#__PURE__*/_jsx("br", {}), formatNumber(Number(tps)), " TPS ", /*#__PURE__*/_jsx("br", {}), formatNumber(Number(throughput)), " \u041C\u0411/\u0441 \u043F\u0440\u043E\u043F\u0443\u0441\u043A\u043D\u0430\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C ", /*#__PURE__*/_jsx("br", {}), formatNumber(Number(usersConnectionsCount)), " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0439 ", /*#__PURE__*/_jsx("br", {}), formatNumber(Number(usersGroupCount)), " \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445 \u0433\u0440\u0443\u043F\u043F ", /*#__PURE__*/_jsx("br", {})]
  });
}
var configTypeItems = [{
  value: ConfigTypeItem.Kafka2_4,
  label: "\u0424\u043B\u0435\u0439\u0432\u043E\u0440 ".concat(ConfigTypeItem.Kafka2_4),
  description: getDescription(ConfigTypeItem.Kafka2_4)
}, {
  value: ConfigTypeItem.Kafka4_8,
  label: "\u0424\u043B\u0435\u0439\u0432\u043E\u0440 ".concat(ConfigTypeItem.Kafka4_8),
  description: getDescription(ConfigTypeItem.Kafka4_8)
}, {
  value: ConfigTypeItem.Kafka8_16,
  label: "\u0424\u043B\u0435\u0439\u0432\u043E\u0440 ".concat(ConfigTypeItem.Kafka8_16),
  description: getDescription(ConfigTypeItem.Kafka8_16)
}, {
  value: ConfigTypeItem.Kafka12_24,
  label: "\u0424\u043B\u0435\u0439\u0432\u043E\u0440 ".concat(ConfigTypeItem.Kafka12_24),
  description: getDescription(ConfigTypeItem.Kafka12_24)
}, {
  value: ConfigTypeItem.Kafka16_32,
  label: "\u0424\u043B\u0435\u0439\u0432\u043E\u0440 ".concat(ConfigTypeItem.Kafka16_32),
  description: getDescription(ConfigTypeItem.Kafka16_32)
}];
export var DMS_KAFKA_FORM_CONFIG = {
  ui: ['configType', ['evs'], ['brokersCount']],
  controls: {
    configType: {
      type: CONTROL.ToggleCards,
      accessorKey: 'config.type',
      defaultValue: ConfigTypeItem.Kafka2_4,
      items: configTypeItems,
      decoratorProps: {
        label: 'Тип конфигурации',
        labelTooltip: 'Данные конфигурации на 1 брокер в кластере'
      },
      onChangeFn: function onChangeFn(value, setValue) {
        setValue([['config', _objectSpread(_objectSpread({}, configItems[value]), {}, {
          type: value
        })]]);
      }
    },
    evs: getDisk({
      space: {
        accessorKey: 'evs.systemDisk.diskSpace',
        defaultValue: 100,
        decoratorProps: {
          label: 'Объем системного диска',
          labelTooltip: /*#__PURE__*/_jsxs(_Fragment, {
            children: ["\u041E\u0431\u044A\u0435\u043C \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u043D\u0430 1 \u0431\u0440\u043E\u043A\u0435\u0440 \u0432 \u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0435", /*#__PURE__*/_jsx("br", {}), "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043E\u0431\u044A\u0435\u043C \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u0438\u0441\u0445\u043E\u0434\u044F \u0438\u0437 \u043E\u0436\u0438\u0434\u0430\u0435\u043C\u043E\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u0438 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0440\u0435\u043F\u043B\u0438\u043A. \u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0435\u0441\u043B\u0438 \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u2014 100 \u0413\u0411, \u0442\u043E \u043E\u0431\u044A\u0435\u043C \u0434\u0438\u0441\u043A\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435: 100 \u0413\u0411 x \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0440\u0435\u043F\u043B\u0438\u043A + 100 \u0413\u0411 (\u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0435 \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u043E)."]
          })
        },
        uiProps: {
          min: 100,
          max: 30000,
          showHint: true
        }
      },
      specification: {
        accessorKey: 'evs.systemDisk.specification',
        defaultValue: 'SSD'
      }
    }),
    brokersCount: {
      type: CONTROL.Stepper,
      decoratorProps: {
        label: 'Количество брокеров'
      },
      accessorKey: 'brokersCount',
      defaultValue: 3,
      uiProps: {
        min: 3,
        max: 50,
        postfix: 'шт'
      }
    },
    // set-default value
    config: {
      type: CONTROL.Segmented,
      accessorKey: 'config',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      defaultValue: configItems[ConfigTypeItem.Kafka2_4],
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      items: [configItems[ConfigTypeItem.Kafka2_4]],
      decoratorProps: {
        label: ''
      },
      uiProps: {
        visible: false
      }
    }
  }
};